import React, { useEffect, useState } from 'react';
import css from './ListingPagecardDetails.module.css';
import NamedLink from '../NamedLink/NamedLink';
import { findOptionsByFilterLabel, findOptionsForSelectFilter } from '../../util/search';
import config from '../../config';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { ReactComponent as LeftArrow } from '../../assets/svg/leftArrow.svg';
import { jobInstrucionOptions, riskFactorOptions } from '../../marketplace-custom-config';
import { ReactComponent as LocationIcon } from '../../assets/locationPinNew.svg';
import BookingPanel from '../BookingPanel/BookingPanel';
import { FaRegEnvelope } from 'react-icons/fa';
import { BsTelephone } from 'react-icons/bs';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { ReactComponent as ChatIcon } from '../../assets/svg/chatOutline.svg';
import {
  TRANSITION_ACCEPT_ASSIGNED_GIG,
  TRANSITION_COMPLETE,
  TRANSITION_GIG_START_NOTIF_BEFORE_1,
  TRANSITION_GIG_START_NOTIF_BEFORE_24,
  TRANSITION_STARTING_JOB,
  TRANSITION_ZERO_CONFIRM_PAYMENT,
} from '../../util/transaction';
import WorkersCard from '../WorkersCard/WorkersCard';
import PendingAcceptanceWorkerCard from '../PendingAcceptanceWorkerCard/PendingAcceptanceWorkerCard';
import RatingAndComment from '../RatingAndComment/RatingAndComment';

const AssignedWorkers = props => {
  const {
    assignedWorkers: propsAssignedWorkers,
    onRemoveWorker,
    listing,
    userNativeLang,
    currentUser,
    history,
  } = props;
  const [assignedWorkers, setAssignedWorkers] = useState(propsAssignedWorkers);

  const removeWorkerFromListing = async params => {
    const newAssignedWorkers = assignedWorkers?.filter(f => f?.id?.uuid !== params.workerId);
    const updatedParams = {
      ...params,
      listingId: listing.id,
      assigendWorkers: newAssignedWorkers.map(wk => wk.id.uuid),
    };
    await onRemoveWorker(updatedParams);
    setAssignedWorkers(newAssignedWorkers);
  };
  useEffect(() => {
    setAssignedWorkers(propsAssignedWorkers);
  }, [propsAssignedWorkers]);

  return assignedWorkers.length > 0 ? (
    <React.Fragment>
      <h3 className={css.workerStatusHeader}>
        <FormattedMessage id="ListingCard.assignedWorkers" />
      </h3>
      <div className={css.workersStatusContainer}>
        {assignedWorkers.map(worker => (
          <PendingAcceptanceWorkerCard
            workerDetails={worker}
            key={worker?.id?.uuid}
            listingId={listing.id.uuid}
            userNativeLang={userNativeLang}
            history={history}
            currentUser={currentUser}
            from={'ListingApplied'}
            removeWorkerFromListing={removeWorkerFromListing}
          />
        ))}
      </div>
    </React.Fragment>
  ) : null;
};

export const ListingPageCardDetailsComponent = props => {
  const {
    listing,
    userNativeLang,
    isProvider,
    alreadyApplied,
    history,
    listingTransactionId,
    currentUser,
    userTxLastTransition,
    assignedWorkers,
    appliedWorkers,
    canceledWorkers,
    isOwnPublishedListing,
    onRemoveWorker,
    intl,
    onManageDisableScrolling,
  } = props;

  const appliedLitingIds =
    currentUser && currentUser?.attributes?.profile?.publicData?.appliedListingId;
  const requestAccepted =
    appliedLitingIds && appliedLitingIds?.length > 0 && !appliedLitingIds.includes(listing.id.uuid);
  const hasAccepted = !!(
    listing.attributes?.metadata?.acceptedWorkers !== undefined &&
    Array.isArray(listing.attributes.metadata.acceptedWorkers) &&
    listing.attributes.metadata.acceptedWorkers.includes(currentUser?.id?.uuid)
  );

  const addressValue =
    listing?.attributes?.publicData?.listingAddress?.[userNativeLang] ||
    listing?.attributes?.publicData?.listingAddress?.address ||
    '';
  const fullAddress = `${addressValue}, ${listing?.attributes?.publicData?.listingAddress.postalCode}`;

  const shortAddres = listing?.attributes?.publicData?.listingAddress?.shortAddress?.default
    ? listing.attributes.publicData.listingAddress.shortAddress[userNativeLang] ||
    listing.attributes.publicData.listingAddress.shortAddress.default
    : fullAddress || '';

  const filterConfig = config.custom.filters;
  const jobCategoryOptions = findOptionsForSelectFilter('category', filterConfig);
  const jobSubCategoryOptions = findOptionsByFilterLabel('Subcategory', filterConfig);
  const reducedJobSubCategory = Object.values(jobSubCategoryOptions).reduce(
    (sum, curr) => [...sum, ...curr],
    []
  );

  const Instruction = listing?.attributes?.publicData?.jobInstruction
    ? jobInstrucionOptions
      .filter(f => listing?.attributes?.publicData?.jobInstruction?.includes(f.value))
      .map(m => m.label[userNativeLang])
    : null;
  const customAddedInstruction = listing?.attributes?.publicData?.newJobInstructionArray
    ? listing?.attributes?.publicData?.newJobInstructionArray
      ?.filter(f => listing?.attributes?.publicData?.jobInstruction?.includes(f.value))
      .map(m => m.label[userNativeLang])
    : null;
  const NewInstruction =
    customAddedInstruction &&
      customAddedInstruction !== undefined &&
      customAddedInstruction !== null
      ? [...(Instruction || []), ...customAddedInstruction]
      : [...(Instruction || [])];
  const languageArray = listing?.attributes?.publicData.languageRequirements;

  const listingAuthor = listing?.author;
  const companyName = listingAuthor?.attributes?.profile?.publicData?.companyName || '';
  const customId = listingAuthor?.attributes?.profile?.publicData?.customId || '';

  const reviwes = listing?.attributes?.reviews || [];

  return (
    <React.Fragment>
      {/* {!isProvider ? ( */}
      {/* <NamedLink
        key="SearchPage"
        name={!isProvider ? 'SearchPage' : 'ManageListingsPage'}
        className={css.jobDetails}
      > */}
      {/* <div className={css.jobDetails} onClick={() => history.goBack()}>
        <LeftArrow />
        <FormattedMessage id="ListingCard.jobDetails" />
      </div> */}

      {/* </NamedLink> */}
      {/* ) : ( */}
      {/* <NamedLink key="ManageListingsPage" name="ManageListingsPage" className={css.jobDetails}>
          <LeftArrow />
          <FormattedMessage id="ListingCard.back" />
        </NamedLink> */}
      {/* )} */}

      <div className={css.mainContainer}>
        <div className={css.leftPartWrapper}>
          <span className={css.title}>{listing?.attributes?.title}</span>
          <div className={css.JobDetailsSubHeadingDiv}>
            <span className={css.category}>
              {
                jobCategoryOptions.filter(f =>
                  listing?.attributes?.publicData.jobCategories.find(m => m.category === f.value)
                )[0].label[userNativeLang]
              }
            </span>
            &nbsp; - &nbsp;
            {
              <span className={css.subcategory}>
                {
                  reducedJobSubCategory.find(
                    m => listing?.attributes?.publicData?.jobCategories[0]?.subCategory === m?.value
                  )?.label[userNativeLang]
                }
              </span>
            }
          </div>
          {(listing?.attributes?.publicData?.listingAddress?.address ||
            listing?.attributes?.publicData?.listingAddress?.postalCode) &&
            hasAccepted ? (
            <div className={css.locationDiv}>
              <div className={css.locateIcon}>
                <LocationIcon className={css.location} />{' '}
              </div>
              <span>{fullAddress}</span>
            </div>
          ) : shortAddres ? (
            <div className={css.locationDiv}>
              <div className={css.locateIcon}>
                <LocationIcon className={css.location} />{' '}
              </div>
              <span>{shortAddres}</span>
            </div>
          ) : null}

          {listing?.attributes?.description ? (
            <div className={css.descContainer}>
              <span>{listing?.attributes?.description}</span>
            </div>
          ) : null}
          <div className={css.afterDescContainer}>
            <div className={css.instructionAndLanguage}>
              {Instruction !== null && Instruction.length > 0 ? (
                <>
                  <div className={css.ListingDetailsPointDiv}>
                    <span className={css.subHeadingTitle}>
                      <FormattedMessage id="listingCardDetails.instruction" />
                    </span>

                    <div>
                      {NewInstruction !== null &&
                        NewInstruction.map((m, indx) => {
                          return (
                            <span className={css.subpoint} key={indx}>
                              {indx + 1 + '. ' + m}. <br />
                            </span>
                          );
                        })}
                    </div>
                  </div>
                </>
              ) : null}

              {languageArray?.length > 0 ? (
                <>
                  <div className={css.ListingDetailsPointDiv}>
                    <span className={css.subHeadingTitle}>
                      <FormattedMessage id="listingCardDetails.languageRequirements" />
                    </span>{' '}
                    {(languageArray || []).map((m, indx) => {
                      return (
                        <div key={indx}>
                          <span className={css.pointMain}>
                            {' '}
                            {m?.language?.label[userNativeLang]}
                          </span>{' '}
                          -{' '}
                          <span className={css.subpoint}>
                            {m.minimumLevel.label[userNativeLang]}
                          </span>
                          <br />
                        </div>
                      );
                    })}
                  </div>
                </>
              ) : null}
            </div>

            {/* This will work when worker is accepted
             for gig and then the condition have to be 
             replaced the "false" condition part  for show the contact details*/}
            {listingTransactionId ? (
              <>
                <div className={css.contactDetails}>
                  {[
                    TRANSITION_STARTING_JOB,
                    TRANSITION_COMPLETE,
                    TRANSITION_ACCEPT_ASSIGNED_GIG,
                    TRANSITION_ZERO_CONFIRM_PAYMENT,
                    TRANSITION_GIG_START_NOTIF_BEFORE_1,
                    TRANSITION_GIG_START_NOTIF_BEFORE_24,
                  ].includes(userTxLastTransition) ? (
                    <>
                      <div className={css.contactHeading}>
                        <FormattedMessage id="EditListingContactForm.contactInfoTabLabel" />
                      </div>
                      <div className={css.contactInfo}>
                        <div className={css.name}>
                          <span>{listing?.attributes?.publicData.contactPersonInfo.firstName}</span>
                          <span>{listing?.attributes?.publicData.contactPersonInfo.lastName}</span>
                        </div>
                        <div className={css.emailDiv}>
                          <FaRegEnvelope />

                          <div className={css.mainEmailLine}>
                            {' '}
                            {listing?.attributes?.publicData.contactPersonInfo.email}
                          </div>
                        </div>
                        {hasAccepted ? (
                          <div className={css.numberDiv}>
                            <BsTelephone />
                            <div className={css.phoneNumLine}>
                              {
                                listing?.attributes?.publicData.contactPersonInfo.phoneNumber
                                  .dialCode
                              }
                              {listing?.attributes?.publicData.contactPersonInfo.phoneNumber
                                .dialCode
                                ? '-'
                                : null}
                              {listing?.attributes?.publicData.contactPersonInfo.phoneNumber.number}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </>
                  ) : null}

                  <button
                    type="button"
                    className={css.chatBtn}
                    onClick={() => {
                      history.push(
                        createResourceLocatorString(
                          'OrderDetailsPage',
                          routeConfiguration(),
                          { id: listingTransactionId },
                          {}
                        )
                      );
                    }}
                  >
                    <ChatIcon />
                    <FormattedMessage id="TransactionPanel.chatWithRecruiter" />
                  </button>
                </div>
              </>
            ) : null}
          </div>
          <div className={css.businessnamenlink}>
            {(isProvider || hasAccepted) && companyName ? (
              <React.Fragment>
                <h2
                  // className={css}
                  onClick={() =>
                    history.push(
                      createResourceLocatorString(
                        'BusinessProfileDisplayPage',
                        routeConfiguration(),
                        { id: listingAuthor?.id?.uuid },
                        {}
                      )
                    )
                  }
                >
                  {companyName}
                </h2>
                {customId ? (
                  <span>
                    {intl.formatMessage({ id: 'ProfileSettingsPage.businessID' })}{' '}
                    {customId.toUpperCase()}
                  </span>
                ) : null}
              </React.Fragment>
            ) : null}

            {isProvider ? null : (
              <div className={css.ratingWrapper}>
                <RatingAndComment
                  onSubmit={() => { }}
                  intl={intl}
                  currentUser={currentUser}
                  onManageDisableScrolling={onManageDisableScrolling}
                  history={history}
                  staffData={{ data: listingAuthor }}
                  reviewsDB={reviwes}
                  showDetailedReviews={false}
                  ratingPointContainerClassName={css.ratingPointContainer}
                />
              </div>
            )}
          </div>
          {isOwnPublishedListing ? (
            <div>
              {appliedWorkers.length > 0 ? (
                <React.Fragment>
                  <h3 className={css.workerStatusHeader}>
                    <FormattedMessage id="ListingCard.appliedWorkers" />
                  </h3>
                  <div className={css.workersStatusContainer}>
                    {appliedWorkers.map((transaction, i) => {
                      const { customer } = transaction;
                      const txId = transaction && transaction?.id && transaction?.id?.uuid;
                      const txLastTransition =
                        transaction && transaction?.id && transaction?.attributes?.lastTransition;

                      return (
                        <WorkersCard
                          listing={listing}
                          workerDetails={customer}
                          workerProfileImages={customer?.profileImage}
                          key={txId}
                          txId={txId}
                          listingId={listing.id.uuid}
                          userNativeLang={userNativeLang}
                          history={history}
                          from={'ListingApplied'}
                          txLastTransition={txLastTransition}
                        />
                      );
                    })}
                  </div>
                </React.Fragment>
              ) : null}

              {canceledWorkers.length > 0 ? (
                <React.Fragment>
                  <h3 className={css.workerStatusHeader}>
                    <FormattedMessage id="ListingCard.cancelledWorkers" />
                  </h3>
                  <div className={css.workersStatusContainer}>
                    {canceledWorkers.map((transaction, i) => {
                      const { customer } = transaction;
                      const txId = transaction && transaction?.id && transaction?.id?.uuid;
                      const txLastTransition =
                        transaction && transaction?.id && transaction?.attributes?.lastTransition;
                      const txLastTransitionAt =
                        transaction &&
                        transaction?.id &&
                        transaction?.attributes?.lastTransitionedAt;

                      return (
                        <WorkersCard
                          listing={listing}
                          workerDetails={customer}
                          workerProfileImages={customer?.profileImage}
                          key={txId}
                          txId={txId}
                          listingId={listing.id.uuid}
                          userNativeLang={userNativeLang}
                          history={history}
                          from={'ListingApplied'}
                          txLastTransition={txLastTransition}
                          canceledAt={txLastTransitionAt}
                        />
                      );
                    })}
                  </div>
                </React.Fragment>
              ) : null}

              <AssignedWorkers
                assignedWorkers={assignedWorkers}
                onRemoveWorker={onRemoveWorker}
                currentUser={currentUser}
                listing={listing}
                history={history}
                userNativeLang={userNativeLang}
              />
            </div>
          ) : null}
        </div>
        {/* <div className={css.rightPartWrapper}>
           hii
          </div> */}
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = state => {
  const { userNativeLang } = state.UI;
  return {
    userNativeLang,
  };
};
const mapDispatchToProps = dispatch => ({});
const ListingPageCardDetails = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(ListingPageCardDetailsComponent);

export default ListingPageCardDetails;
